// ── Słownik „Miejsce powstawania kosztów" (MPK, struktura drzewiasta) ───────
// Budowany przez użytkownika w Ustawieniach → Słowniki. Wykorzystywany m.in.
// w polu MPK na etapie dekretacji księgowej faktury. Persistencja (mock) w
// localStorage — docelowo źródłem będzie BE.

export interface IMppNode {
  id: string;
  code: string; // opcjonalny symbol/kod
  label: string;
  children: IMppNode[];
}

export const MPP_STORAGE_KEY = "mpp_tree_v1";

export const loadMppTree = (): IMppNode[] => {
  try {
    const raw = localStorage.getItem(MPP_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as IMppNode[]) : [];
  } catch {
    return [];
  }
};

export const saveMppTree = (nodes: IMppNode[]) => {
  try {
    localStorage.setItem(MPP_STORAGE_KEY, JSON.stringify(nodes));
  } catch {
    /* brak miejsca w localStorage — ignorujemy (mock) */
  }
};

// Spłaszczenie drzewa do listy wyboru (np. w polu MPK) — ze ścieżką nadrzędną.
export interface IMppFlat {
  id: string;
  code: string;
  label: string;
  path: string; // „Korzeń / Węzeł / Liść"
}

export const flattenMpp = (nodes: IMppNode[], prefix = ""): IMppFlat[] => {
  const out: IMppFlat[] = [];
  for (const n of nodes) {
    const path = prefix ? `${prefix} / ${n.label}` : n.label;
    out.push({ id: n.id, code: n.code, label: n.label, path });
    if (n.children.length) out.push(...flattenMpp(n.children, path));
  }
  return out;
};
